import styled from '@emotion/styled';
import { Chip } from '@material-ui/core';
import { COLOR_TEXT_MAIN } from '../../../../theme/colors';

const StyledChip = styled(Chip)<{ selected: boolean }>`
  border: 1.5px solid ${(props) => (props.selected ? '#E6E7E8' : COLOR_TEXT_MAIN)};
  margin-right: 8px;
  margin-bottom: 8px;
  color: ${COLOR_TEXT_MAIN};
  font-weight: 700;
  background-color: ${(props) => (props.selected ? '#F5F6F7' : undefined)};
`;

export default StyledChip;
